import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_single_line_address_banner = _resolveComponent("single-line-address-banner")!
  const _component_single_line_address = _resolveComponent("single-line-address")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("link", {
      rel: "stylesheet",
      href: _ctx.cssUrl
    }, null, 8, _hoisted_1),
    (_ctx.type)
      ? (_openBlock(), _createBlock(_component_single_line_address_banner, {
          key: 0,
          class: _normalizeClass(`theme--${_ctx.platform}`),
          layout: _ctx.layout,
          target: _ctx.target,
          type: _ctx.type,
          logo: _ctx.logo,
          platform: _ctx.platform,
          "floating-button": _ctx.floatingButton,
          "no-floating-button": _ctx.noFloatingButton,
          "m-tracking": _ctx.mTracking
        }, null, 8, ["class", "layout", "target", "type", "logo", "platform", "floating-button", "no-floating-button", "m-tracking"]))
      : (_openBlock(), _createBlock(_component_single_line_address, {
          key: 1,
          class: _normalizeClass(`theme--${_ctx.platform}`),
          layout: _ctx.layout,
          target: _ctx.target,
          platform: _ctx.platform,
          "floating-button": _ctx.floatingButton,
          "no-floating-button": _ctx.noFloatingButton,
          "m-tracking": _ctx.mTracking
        }, null, 8, ["class", "layout", "target", "platform", "floating-button", "no-floating-button", "m-tracking"]))
  ], 64))
}